import React from 'react';
import { useLocation } from 'react-router-dom';

import './Header.scss';
import Navigation from '../navigation/Navigation';
import Search from '../search/Search';
import { IData } from '../../interfaces/IData';

type HeaderProps = {
  content: IData | undefined;
  search: (data: string) => void;
}

const Header = ({content, search}: HeaderProps) => {
  const isHome = useLocation().pathname === '/';

  if (!content) {
    return null;
  }

  return (
    <header className="site-header">
      <Navigation search={search} content={content} />

      {isHome && (
        <div className="mobile-search">
          <Search setKeyword={search} />
        </div>
      )}
    </header>
  );
};

export default Header;
